export default {
  NAME_VALIDATE: /(^[А-ЯЁA-Z]{1}[а-яёА-ЯЁa-zA-Z\s-]+$)/,
  RUS_VALIDATE: /(^[а-яёА-ЯЁ\s-]+$)/,
  EMAIL_VALIDATE: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
  PASSWORD_VALIDATE: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/,
  CARD_NUMBER: /[0-9]{13,19}/,
  CODE: /^[0-9a-zA-Z]{6}$/,
  PHONE: /^([0-9]{1})([0-9]{3})([0-9]{3})([0-9]{2})([0-9]{2})$/,
};
